import { render, staticRenderFns } from "./add.vue?vue&type=template&id=59a222d6&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a222d6')) {
      api.createRecord('59a222d6', component.options)
    } else {
      api.reload('59a222d6', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=59a222d6&", function () {
      api.rerender('59a222d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/buildingUnit/add.vue"
export default component.exports